<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%" class="mx-n3 px-3">
            <list-heading title="자재연결 상세" />
            <v-row class="ma-n2">
                <v-col cols="12" lg="4" class="pa-2">
                    <v-row class="ma-n2" align="center">
                        <v-col cols="12" class="pa-2">
                            <manufacturing-material-basic v-bind="{ loading, material }">
                                <template #actions>
                                    <v-layout class="my-n3">
                                        <v-btn small text fab tile color="grey">
                                            <v-icon>mdi-home</v-icon>
                                        </v-btn>
                                        <template v-if="material?.href">
                                            <v-btn small text fab tile color="info" :href="material.href" target="_blankreset .">
                                                <v-icon>mdi-store</v-icon>
                                            </v-btn>
                                        </template>
                                        <template v-if="material?.sheet">
                                            <v-btn small text fab tile color="info" :href="material.sheet" target="_blankreset .">
                                                <v-icon>mdi-file-pdf-box</v-icon>
                                            </v-btn>
                                        </template>
                                        <manufacturing-material-search v-bind="{ material }" v-on="{ updateLinkItem }">
                                            <template #activator="{ attrs, on }">
                                                <v-btn small text fab tile v-bind="attrs" v-on="on" color="primary">
                                                    <v-icon>mdi-link-variant-plus</v-icon>
                                                </v-btn>
                                            </template>
                                        </manufacturing-material-search>
                                    </v-layout>
                                </template>
                            </manufacturing-material-basic>
                        </v-col>
                        <v-col cols="12" class="pa-2">
                            <manufacturing-material-brief v-bind="{ loading, material }" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="8" class="pa-2">
                    <manufacturing-material-links v-bind="{ material }" v-on="{ updateLinkItem, init }" />
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initManufacturingMaterial } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import ManufacturingMaterialBasic from "@/components/console/manufacturing/material/view/manufacturing-material-basic.vue";
import ManufacturingMaterialBrief from "@/components/console/manufacturing/material/view/manufacturing-material-brief.vue";
import ManufacturingMaterialLinks from "@/components/console/manufacturing/material/view/manufacturing-material-links.vue";
import ManufacturingMaterialSearch from "@/components/console/manufacturing/material/view/manufacturing-material-search.vue";

export default {
    components: {
        ListHeading,
        ManufacturingMaterialBasic,
        ManufacturingMaterialBrief,
        ManufacturingMaterialLinks,
        ManufacturingMaterialSearch,
    },
    props: {
        _id: { type: String, default: null },
    },
    data: () => ({
        material: initManufacturingMaterial(),

        loading: false,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { _id } = this;
                const { material } = await api.console.manufacturing.materials.get({ _id });

                this.material = initManufacturingMaterial(material);
            } finally {
                this.loading = false;
            }
        },
        updateLinkItem(item) {
            const index = this.material.links.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.material.links.splice(index, 1, item);
            else this.material.links = [item, ...this.material.links];
            this.init();
        },
    },
};
</script>

<style lang="scss" scoped></style>
